var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox } from "../../../../../Components/Forms";
import { t, Translate } from "../../../../../../I18N";
import { Tooltip } from 'flowbite-react';
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';

export const GeneratedIdField = ({ control }) => /*#__PURE__*/
_jsx(Controller, {
  name: "generatedId",
  control: control,
  render: ({ field }) => /*#__PURE__*/
  _jsx(Checkbox, {
    name: "generatedId",
    checked: field.value,
    onChange: (e) => field.onChange(e.target.checked),
    label: /*#__PURE__*/
    _jsx("span", { className: "flex items-center gap-1" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Generated ID"), ' ', /*#__PURE__*/
    _jsx(Tooltip
    // eslint-disable-next-line react/style-prop-object
    , { style: "light",
      content: t('System', 'A generated ID will be the default title.', null, false),
      placement: "right" }, void 0, /*#__PURE__*/

    _jsx(QuestionMarkCircleIcon, { className: "w-5 h-5 text-gray-500" })
    )
    ) }

  ) }

);